<template>
  <static-fullscreen-card @sendHeight="setContentHeight">
    <template v-slot:title>{{ data.city }}. {{ data.address_fact && data.address_fact.address }} ({{ data.id }})</template>
    <template v-slot:actions>
      <v-btn color="primary" @click="onEdit" title="Редактировать"><btn-title icon="far fa-edit">Редактировать</btn-title></v-btn>
    </template>
    <portal to="v-goup" v-if="idShow">
      <v-btn class="mr-3" fab small @click="$emit('close', data)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </portal>
    <portal to="v-main">
      <s-edit-form
        v-model="showEditDialog"
        v-if="showEditDialog"
        :m="configH.m"
        :configForm="{ head: configH.head, title: configH.title, api: configH.api }"
        :id="configH.id"
        :opt="configH.opt"
      />
    </portal>
    <a-loader v-if="!loaded" />
    <v-row v-else>
      <v-col cols="12" sm="6">
        <material-card>
          <template v-slot:heading> </template>
          <a-form-view :value="data" :model="modelLeft" />
        </material-card>
      </v-col>
      <v-col cols="12" sm="6">
        <material-card>
          <template v-slot:heading> </template>
          <a-form-view :value="data" :model="modelRight" />
        </material-card>
      </v-col>
      <v-col cols="12">
        <material-card color="third" class="block_detail">
          <template v-slot:heading>
            <v-tabs v-model="tab" background-color="transparent" slider-color="white" height="44">
              <v-tab v-for="(tab, i) in tabs" v-if="tab.show" :key="i" class="mr-3" :href="`#tab-${tab.name}`">
                {{ tab.title }}
              </v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab" class="transparent" style="min-height: 200px" touchless>
            <v-tab-item v-for="(t, i) in tabs" :key="i" v-if="t.show" :id="`tab-${t.name}`">
              <TabSupply v-if="t.name == 'supply'" :id="data.id" :height="detailHeight" />
              <TabDocs v-if="t.name == 'doc'" :data="data" :height="detailHeight" />
            </v-tab-item> </v-tabs-items
        ></material-card>
      </v-col>
    </v-row>
  </static-fullscreen-card>
</template>

<script>
import { autoHeightBlock, getAccess, popupMenu, removeEl, genModel } from "@/components/mixings";
export default {
  mixins: [autoHeightBlock, getAccess, popupMenu, removeEl, genModel],
  props: {
    idShow: Number,
  },
  components: {
    TabSupply: () => import("./tabs/tabSupply"),
    TabDocs: () => import("./tabs/tabDocs"),
  },
  data() {
    return {
      loaded: false,
      id: 0,
      showEditDialog: false,
      configH: null,
      suEditShow: false,
      showSalesDialog: false,
      title: "",
      m: this.$store.getters["config/get"].models.creditOrg,
      data: {},
      tab: 0,
      tab_photo: 0,
      tabs: [
        { name: "supply", title: "Поставки", show: !true },
        { name: "doc", title: "Документы", show: true },
        { name: "report", title: "Отчеты", show: this.getAccess("shop.accounting") || !true },
      ],
    };
  },

  created() {
    this.$root.title = this.m.title;
    this.id = this.idShow || Number(this.$route.params.id);
    this.fitchData();
  },
  computed: {
    configHead() {
      let type = this.$root.profile.role;
      let config = JSON.parse(JSON.stringify(this.m?.config?.[type] || this.m?.config.default || {}));
      return config || {};
    },
    url() {
      return this.m.api;
    },
    modelLeft() {
      let model = this.calcModel("viewForm1");
      return model;
    },
    modelRight() {
      let model = this.calcModel("viewForm2");
      return model;
    },
    model: {
      get() {
        let model = this.calcModelConfig(this.configHead);
        return model;
      },
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.fitchData();
      }
    },
  },
  methods: {
    async fitchData() {
      const d = await this.$axios.get(this.url + "/" + this.id);
      if (d.data && d.data.data) {
        this.data = d.data.data;
        this.loaded = true;
      }
    },
    onEdit() {
      const config = {};
      this.configH = null;
      config.head = this.m.config.default || {};
      config.title = this.m.config.default.title || this.m.title || "";
      config.api = this.url;
      config.id = this.id;
      config.opt = this.getAccess("creditOrg.delete") ? "delete" : "";
      config.m = this.m;
      this.configH = config;

      this.showEditDialog = true;
    },
  },
};
</script>
